module.exports = __webpack_public_path__ + "static/media/op.60c8fdb6.png";